import { atomWithStorage } from 'jotai/utils'

export type PatientInfoButtonBehavior = 'deeplink-only' | 'answer-then-deeplink'

export const patientInfoButtonBehaviorAtom =
  atomWithStorage<PatientInfoButtonBehavior>(
    'patientInfoButtonBehavior',
    'deeplink-only',
  )
